import { useEffect } from 'react';

function useInsertRemoveTabs({ tabsRef, context, setIsTabFocused, focusedTabIndex, setFocusedTabIndex, }, [...deps]) {
    const getTabIndexByKey = (tabKey) => {
        return tabsRef.current.findIndex((el) => {
            return el.id === tabKey;
        });
    };
    const getTabIndexFromPreviousTab = () => {
        const tabsRefArray = tabsRef.current;
        const lastTabIndex = tabsRefArray.length - 1;
        const isFirstTab = focusedTabIndex === 0;
        const prevTabIndex = isFirstTab ? lastTabIndex : focusedTabIndex - 1;
        return prevTabIndex;
    };
    const handleDyanamicTabs = () => {
        var _a;
        const tabsRefArray = tabsRef.current;
        if (!tabsRefArray.length)
            return;
        const currentTabIndex = getTabIndexByKey(context.currentTab);
        const hasTabBeenRemoved = currentTabIndex === -1;
        if (hasTabBeenRemoved) {
            const prevTabIndex = getTabIndexFromPreviousTab();
            const tabButton = tabsRefArray[prevTabIndex];
            setIsTabFocused(prevTabIndex);
            (_a = context === null || context === void 0 ? void 0 : context.onChange) === null || _a === void 0 ? void 0 : _a.call(context, tabButton === null || tabButton === void 0 ? void 0 : tabButton.id);
        }
        else {
            if (currentTabIndex === focusedTabIndex)
                return;
            setFocusedTabIndex(currentTabIndex);
        }
    };
    useEffect(() => {
        handleDyanamicTabs();
    }, [deps]);
}

export { useInsertRemoveTabs };
